import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Asynchronous from './Asynchronous';
import { FiltersRibbonPropTypes, HeaderPropTypes } from 'src/interfaces/iproptypes';
import { VerifiedTag } from '../../Tags';

const useStyles = makeStyles(theme => ({
  root: {
    // paddingTop: theme.spacing(3),
    color: 'white',
    zIndex: 500,
    [theme.breakpoints.down(900)]: {
      marginBottom: 20,
    },
  },
  highlightActive: {
    padding: '5px',
    paddingTop: '10px',
    border: '7px solid #65ccb8',
    borderRadius: '5px',
  },
}));

const FiltersRibbon = ({
  search,
  dashboardState,
  setdashboardState,
  matches,
  user,
  district,
  isUserVerified,
  rateLimitAlert,
  setRateLimitAlert,
  googleAutocompleteSessionToken,
  getGoogleAutocompleteSessionToken,
  clearGoogleAutocompleteSessionToken,
  googleAutocompleteSessionTokenTimeStamp,
  cachedSearchMarkets,
  appTourStep,
  SearchBar,
}: FiltersRibbonPropTypes) => {
  const classes = useStyles();

  const [checked, setChecked] = useState<boolean>(false);

  const handleSearachInputChange = () => {
    setChecked(true);
  };

  const handleSearchInputNoNeed = () => {
    setChecked(false);
  };

  const currentPath = window.location.pathname;
  const isHomePage =
    !dashboardState.showMyAnalysisDashboard &&
    (currentPath === '/' || currentPath === '/airbnb-data' || currentPath === '/airbnb-data/');

  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={1}
      className={classes.root}
    >
      <Grid item xs={12} md={11} lg={11}>
        {!isHomePage && (
          <div id="searchBar" style={{maxWidth: '500px', width: '40vw'}}>
            {SearchBar}
          </div>
        )}
      </Grid>

      {/* {!isHomePage && search.data.isVerified && !matches && (
        <Grid item xs={1}>
          <VerifiedTag />
        </Grid>
      )} */}
    </Grid>
  );
};

FiltersRibbon.propTypes = {
  filterChange: PropTypes.func,
  getGraphData: PropTypes.func,
  getSearch: PropTypes.func,
};

export default FiltersRibbon;
